import React from 'react';
import { Flex, Space, theme, Typography } from 'antd';
import { t } from '../../../utils';
import { AddVariables } from '../AddVariables';
import Roles from '../Roles';

const { Text } = Typography;

export const DocumentMetaData = () => {
	const { token } = theme.useToken();
	const items = [
		{
			label: t('startPage.roleLabel'),
			description: t('startPage.roleDescription'),
			children: <Roles />,
		},
		{
			label: t('variables.label'),
			description: t('variables.description'),
			children: <AddVariables />,
		},
	];

	return (
		<Space direction="vertical" size="large">
			{items.map((item, index) => (
				<Flex key={index} style={{ marginBlockEnd: token.marginLG }}>
					<DocumentMetaDataItem {...item} />
				</Flex>
			))}
		</Space>
	);
};

type ItemProps = {
	label?: string;
	description?: string;
	children: React.ReactNode;
};

export const DocumentMetaDataItem = ({ label, description, children }: ItemProps) => {
	return (
		<Flex vertical gap="15px" style={{ width: '100%' }}>
			{label && <Text strong>{label}</Text>}
			{description && <Text type="secondary">{description}</Text>}
			{children}
		</Flex>
	);
};
